import { lazy } from 'react';
import { ModuleConfig } from '../../types/ModuleConfig';

export const modulesModuleConfig: ModuleConfig = {
  id: 'modules',
  name: 'Modules Directory',
  icon: '📦',
  color: 'blue',
  description: 'Browse and discover all available system modules',
  version: '1.0.0',
  enabled: true,
  category: 'core',
  order: 100,
  routes: [
    {
      path: '/modules',
      component: lazy(() => import('./ModulesDirectory')),
      exact: true,
      permissions: [], // Public route
      useLayout: true
    },
    {
      path: '/modules/:moduleId',
      component: lazy(() => import('./ModuleDetails')),
      exact: true,
      permissions: [], // Public route
      useLayout: true
    }
  ],
  navigation: [
    {
      label: 'Modules',
      path: '/modules',
      icon: '📦',
      permissions: []
    }
  ],
  permissions: {
    view: [], // Public
    create: [],
    edit: [],
    delete: []
  },
  quickActions: [],
  changelog: [
    {
      version: '1.0.0',
      releaseDate: '2025-11-22',
      title: 'Initial Release - Modules Directory',
      features: [
        '✅ Public-facing modules directory',
        '✅ Modules grouped by subscription tier (Foundation → Dominance)',
        '✅ Reusable ModuleCard component',
        '✅ Display module icon, name, description, version',
        '✅ Show ACTIVE badge for enabled modules',
        '✅ What\'s New button for modules with release notes',
        '✅ Tier information with pricing and descriptions',
        '✅ Responsive grid layout',
        '✅ GraphQL integration with availableModules endpoint'
      ],
      notes: 'First release of the centralized modules directory. Provides a public-facing showcase of all available system modules organized by subscription tier. Users can browse features and navigate to What\'s New pages for modules that have them.'
    }
  ],
  roadmap: []
};

export default modulesModuleConfig;
